import React from 'react';
import _get from 'lodash/get';

import StoreSelect from './StoreSelect';
import { useStoreSwitch } from 'utils/hooks';
import StoreSwitchModal from './StoreSwitchModal';

export default function StoreSwitch() {
  const {
    storeData,
    isSwitching,
    isValidating,
    isProcessing,
    onCloseModal,
    onStoreSwitch
  } = useStoreSwitch();

  const storeName = _get(storeData, 'storeName', '');
  const storeUniqueName = _get(storeData, 'storeUniqueName', '');

  return (
    <>
      <StoreSelect onChange={onStoreSwitch} />
      <StoreSwitchModal
        isOpen={!!storeData}
        storeName={`${storeName} (${storeUniqueName})`}
        isSwitching={isSwitching}
        isValidating={isValidating}
        isProcessing={isProcessing}
        onClose={onCloseModal}
      />
    </>
  );
}
